import axios from 'axios';
import { getApiBaseUrl, getStudentToken } from './typingTutorUtils';

const API = getApiBaseUrl();

const authHeaders = () => ({
  Authorization: `Bearer ${getStudentToken()}`,
});

export const fetchTypingProgress = async () => {
  const { data } = await axios.get(`${API}/typing-tutor/progress`, {
    headers: authHeaders(),
  });
  return data.progress;
};

export const fetchTypingSessions = async (params = {}) => {
  const { data } = await axios.get(`${API}/typing-tutor/sessions`, {
    headers: authHeaders(),
    params,
  });
  return data.sessions;
};

export const saveTypingSession = async (payload) => {
  const { data } = await axios.post(`${API}/typing-tutor/sessions`, payload, {
    headers: authHeaders(),
  });
  return data;
};

export const fetchCourseStories = async () => {
  const { data } = await axios.get(`${API}/typing-tutor/stories`, {
    headers: authHeaders(),
  });
  return data;
};

export const fetchCourseStory = async (storyId) => {
  const { data } = await axios.get(`${API}/typing-tutor/stories/${storyId}`, {
    headers: authHeaders(),
  });
  return data.story;
};

export const translateStoryText = async (text, sourceLang = 'auto') => {
  const { data } = await axios.post(
    `${API}/typing-tutor/stories/translate`,
    { text, sourceLang },
    { headers: authHeaders() },
  );
  return data;
};
